import { render } from "./ConsolePage.vue?vue&type=template&id=0c7d8775&scoped=true"
import script from "./ConsolePage.vue?vue&type=script&lang=js"
export * from "./ConsolePage.vue?vue&type=script&lang=js"

import "./ConsolePage.vue?vue&type=style&index=0&id=0c7d8775&lang=scss&scoped=true"
import "./ConsolePage.vue?vue&type=style&index=1&id=0c7d8775&lang=css"

import exportComponent from "C:\\Users\\crescendoCat\\Work Space\\Nodejs\\thripsui\\vue-thripsui\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c7d8775"]])

export default __exports__